
import './App.css';
import CategoryPage from './components/CategoryPage';
import HomePage from "./components/HomePage";
import GameDetails from './components/GameDetails';
import { BrowserRouter as Router ,Routes,Route } from 'react-router-dom';
import SearchBox from './components/SearchBox';
import Login from './components/Login';
import Redirect from './components/Redirect';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// import Footer from './components/Footer';

function App() {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage/>}/>
          <Route path='/redirect' element={<Redirect/>} />
          <Route path="/games/:gameid" element={<GameDetails/>}/>
          <Route path="/category/:categoryName" element={<CategoryPage/>}/> 
          <Route path="/subscribe" element={<Login/>}/>
        </Routes>
        
      </Router>
      <ToastContainer/>
      {/* <Footer/> */}
    </div>
  );
}

export default App;

  